import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { OPTIONS, QUESTIONS, SKILLS } from "@/lib/softskills";

export const QuizQuestion = ({ index, value, onAnswer, onBack }) => {
  const q = QUESTIONS[index];
  const skill = SKILLS.find((s) => s.key === q.skill);
  const progress = (index / QUESTIONS.length) * 100;

  return (
    <div data-testid="quiz-question" className="mx-auto w-full max-w-3xl">
      <div className="mb-10 flex items-center justify-between font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">
        <button data-testid="quiz-back-btn" onClick={onBack} disabled={index === 0} className="flex items-center gap-2 hover:text-[#c4dcca] disabled:opacity-30">
          <ArrowLeft size={14} /> Indietro
        </button>
        <span data-testid="quiz-progress-label">{index + 1} / {QUESTIONS.length}</span>
      </div>
      <div className="mb-12 h-1 bg-white/10">
        <motion.div className="h-full bg-[#98bfa2]" initial={false} animate={{ width: `${progress}%` }} transition={{ duration: 0.4 }} />
      </div>
      <motion.div key={index} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}>
        <p className="eyebrow mb-4">{skill?.short}</p>
        <h2 data-testid="quiz-question-text" className="font-display text-4xl font-900 uppercase leading-[0.95] md:text-6xl">{q.text}</h2>
        <p className="mt-6 text-sm text-[#a3b1aa]">Quanto ti descrive questa frase?</p>
        <div className="mt-6 grid gap-2 sm:grid-cols-5">
          {OPTIONS.map((label, i) => {
            const v = i + 1;
            const active = value === v;
            return (
              <button key={label} data-testid={`quiz-option-${v}`} onClick={() => onAnswer(v)}
                className={`flex items-center gap-3 border px-4 py-4 text-left transition-colors sm:flex-col sm:items-start sm:gap-6 ${active ? "border-[#c4dcca] bg-[#98bfa2] text-[#050807]" : "border-[rgba(152,191,162,0.25)] hover:border-[#c4dcca] hover:bg-[#0b120e]"}`}>
                <span className="font-display text-3xl font-900 leading-none">{v}</span>
                <span className="text-sm">{label}</span>
              </button>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};
